<template>
    <div id="recommend-or-compose-pack-navigation" class="container px-0">
        <nav class="ob1-menu-page ob1-menu-page-fullscreen ob1-menu-page-icon" style="height: auto !important;">
            <ul class="nav ob1-nav-light">
                <!-- offres broadband -->
                <li
                    class="nav-item"
                    :class="{ 'active': showBasicsOffers }"
                    style="width: 50%;"
                >
                    <button
                        class="nav-link px-0"
                        :data-oevent-category="tmsTabInternetOffer.category"
                        :data-oevent-action="tmsTabInternetOffer.action"
                        :data-oevent-label="tmsTabInternetOffer.label"
                        @click="changeSelectedTab(hashTagInternet)"
                    >
                        <span
                            class="item-icon"
                            :class="attributesTabInternetOfferIcon"
                            aria-hidden="true"
                        />{{ attributesTabInternetOfferLabel }}
                    </button>
                </li>
                <!-- offres broadband + smart TV -->
                <li
                    class="nav-item"
                    :class="{ 'active': !showBasicsOffers }"
                    style="width: 50%;"
                >
                    <button
                        class="nav-link px-0"
                        :data-oevent-category="tmsTabInternetAndTvOffer.category"
                        :data-oevent-action="tmsTabInternetAndTvOffer.action"
                        :data-oevent-label="tmsTabInternetAndTvOffer.label"
                        @click="changeSelectedTab(hashTagInternetSmartTv)"
                    >
                        <span
                            class="item-icon"
                            :class="attributesTabInternetAndTvOfferIcon"
                            aria-hidden="true"
                        />{{ attributesTabInternetAndTvOfferLabel }}
                    </button>
                </li>
            </ul>
        </nav>
    </div>
</template>

<script>

export default {
    name: "OffersTabs",
    components: {
    },
    props: {
        token: {type: String, required: false, default: ""},
        attributesTabInternetOfferLabel: {type: String, required: true},
        attributesTabInternetOfferIcon: {type: String, required: true},
        attributesTabInternetAndTvOfferLabel: {type: String, required: true},
        attributesTabInternetAndTvOfferIcon: {type: String, required: true},
        tmsTabInternetOffer: {type: Object, required: true},
        tmsTabInternetAndTvOffer: {type: Object, required: true}
    },
    data() {
        return {
            hashTagInternet: "internet",
            hashTagInternetSmartTv: "internet_smart_tv",
            hashTag: undefined,
        }
    },
    computed: {
        showBasicsOffers() {
            if ((this.hashTag) && (this.hashTag !== "")) {
                if (this.hashTag === this.hashTagInternetSmartTv) {
                    this.changeSelectedTab(this.hashTagInternetSmartTv);
                }
                else {
                    this.changeSelectedTab(this.hashTagInternet);
                }
                // Si un hashTag existe, définir showBasicsOffers à partir du hashTag
                return (this.hashTag !== this.hashTagInternetSmartTv);
            }
            return true;
        },
    },
    mounted() {
        window.addEventListener("hashchange", this.updateSelectedTabFromHash);
        this.updateSelectedTabFromHash();
    },
    beforeDestroy: function () {
        window.removeEventListener("hashchange", this.updateSelectedTabFromHash);
    },
    methods: {
        readHash() {
            const hash = window.location.hash;
            return hash.startsWith("#") ? hash.substring(1) : hash
        },
        updateSelectedTabFromHash() {
            const hash = this.readHash();
            if (hash !== this.hashTag) {
                if (hash === "") {
                    this.hashTag = "";
                } else if ([this.hashTagInternet, this.hashTagInternetSmartTv].includes(hash)) {
                    this.hashTag = hash;
                }
            }
        },
        changeSelectedTab(e) {
            if ((e !== "") && ([this.hashTagInternet, this.hashTagInternetSmartTv].includes(e))) {
                window.location.href = "#"+e;
                this.$emit('toggle-tab', { tab: e });
            }
        },
    }
}
</script>

<style scoped lang="scss">

</style>
